import { render } from "./StoreFooter.vue?vue&type=template&id=74bc2d0a"
import script from "./StoreFooter.vue?vue&type=script&lang=js"
export * from "./StoreFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__